export default "__VITE_ASSET__PQmx4pV5__"